
// This module must be imported before @dpgradio/creative so that it runs
// before the Hybrid constructor. It removes the early-capture stubs from
// index.html so that ensureTriggerExists can install the actual dispatchers.
['appLoad', 'authenticated', 'didAppear'].forEach((name) => {
  if (window[name] && !window[name]._hybridDispatcher) {
    delete window[name]
  }
})
